import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRoleMainComponent } from './user-role-main/user-role-main.component';

const routes: Routes = [
  {
    path: '', 
    component: UserRoleMainComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class UserRoleRoutingModule { }
